// @flow

import LazyLoad from 'react-lazyload';
import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import { IMGIX_HOST } from 'web-ssr/app/common/constants';
import { buildOptimzedImageUrl } from 'web-ssr/app/common/utils/UrlUtils';
import { buildStaticAssetPath } from 'web-ssr/app/common/next/utils';
import 'web-ssr/app/common/components/Img.scss';

import type { KindType } from 'web-ssr/app/common/types';

const bem = bemify('image');

export type Props = {
  src: string,
  alt: string,
  width?: number,
  height?: number,
  maxDownloadWidth?: number,
  className?: string,
  kind?: KindType,
  format?: string,
  background?: string,
  ariaHidden?: boolean,
  enableThrottle?: boolean,
};

const placeholderImage = buildStaticAssetPath('images/zapier-logo.png');

const Img = (props: Props) => {
  const {
    ariaHidden,
    src,
    className,
    width,
    height,
    alt,
    kind,
    maxDownloadWidth,
    format,
    background,
    enableThrottle,
  } = props;

  const alreadyOptimized = src.includes(IMGIX_HOST);
  const sourceUrl = alreadyOptimized
    ? src
    : buildOptimzedImageUrl(src, maxDownloadWidth, format, background);

  return (
    <LazyLoad offset={100} once={true} throttle={enableThrottle}>
      <img
        alt={alt}
        aria-hidden={ariaHidden}
        className={bem(className, toModifiers(kind))}
        height={height}
        src={sourceUrl}
        width={width}
      />
    </LazyLoad>
  );
};

Img.defaultProps = {
  src: placeholderImage,
  ariaHidden: false,
  enableThrottle: true,
};

export default Img;
